import { RootState } from "../../../../store";
import { dimensionsSliceSelector } from "../../dimensionsSliceSelector";

export const editingCategoryIdSelector = (state: RootState) => {
  const slice = dimensionsSliceSelector(state);

  return slice.editingCategoryId;
};
